<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('gym member promotions')"
      :columns="columns"
      :column_search="true"
      resource_url="/gym_member/member-promotion/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="payments">
          <span class="icon"><i class="fa fa-money"></i></span>
          <span>{{ $t("payments") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
    </generic-table>
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  success_message,
  error_message,
  format_currency,
  api_host,
  format_date,
} from "@/utils";
import VLazyImage from "v-lazy-image";
import moment from "moment";

export default {
  name: "GymMemberPromotion",
  components: {
    GenericTable,
    VLazyImage,
  },
  props: {},
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("date"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("member"),
          searchable: false,
          // width: "70%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.gym_member.name || "";
          },
        },
        {
          title: v.$t("promotion"),
          searchable: false,
          // width: "70%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.promotion.name || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   // width: "70%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          //width: "30%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete member promotion?"),
                    v,
                    () => {
                      del("/gym_member/member-promotion", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    moment,
    create() {
      let v = this;
      v.$refs.gym_member_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    hide_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) {
        setTimeout(() => {
          trgt_menu.removeClass("is-active");
        }, 200);
      }
    },
    show_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) trgt_menu.addClass("is-active");
    },
    edit_member(element) {
      let v = this;
      v.$refs.edit_gym_member_modal.show_modal(element.uuid);
    },
    buy_promotion(element) {
      let v = this;
      v.$refs.buy_promotion_modal.show_modal(element);
    },
    register_payment(element) {
      let v = this;
      v.$refs.payment_modal.show_modal(element);
    },
    account_details(element) {
      let v = this;
      v.$refs.account_modal.show_modal(element);
    },
    update_expire_membership(element) {
      let v = this;
      v.$refs.update_expire_membership_modal.show_modal(element);
    },
    delete_member(element) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete member?"), v, () => {
        del("/gym_member", { uuid: element.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    send_qr(element) {
      let v = this;
      v.$root.loader(true);
      put("/gym_member/qr", { uuid: element.uuid })
        .then(() => {
          success_message(v.$t("qr code sent"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    payments() {
      let v = this;
      v.$router.push({ path: "/gym_member/payments" });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
